/* globals google */
"use strict";

const base = require("./base");
const slickCarousel = require("../global/slickCarousel");
const lazyLoading = require("../global/lazyLoading");

const $body = $("body");
const $document = $(document);

/**
 * @function
 * @description Function to load Stringing Configuration
 * @param {string} configURL url with appended parameters
 */
const loadStringingConfig = configURL => {
    let pid = $(".m-product-detail").data("pid");

    $.ajax({
        url: configURL + "?pid=" + pid,
        type: "get",
        success: data => {
            $("#config-stringing").html(data);

            if ($(".m-product-detail__stringing-carousel").length) {
                slickCarousel.initSlickSlider(".m-product-detail__stringing-carousel .slick-slider");
                lazyLoading.refreshLazyLoadingFeature(".m-product-detail__stringing-carousel img");

                if (!window.mqRespond.status.lgDown && $(".stringing-tooltip").length) {
                    $("[data-toggle='tooltip']").each((i, el) => {
                        $(el).tooltip({
                            container: $(el).parent(),
                            placement: "bottom",
                            delay: { "show": 2000, "hide": 100 }
                        });
                    });
                }

                setTimeout(() => {
                    let $shopButton = $(".btn-stringing");
                    let $playTestButton = $(".play-test-stringable");
                    let topScroll = $shopButton.offset() && $shopButton.offset().top > 0 ? $shopButton.offset().top : $playTestButton.offset().top;
                    let scrollReduceAmount =  $shopButton.offset() && $shopButton.offset().top > 0 ? $(".l-header").height() : 0;
                    $("html, body").animate({ scrollTop: topScroll - scrollReduceAmount }, "slow");
                }, 200);
            }
        }
    });
};

/**
 * @function
 * @description Function to get the Tension instructions section height and manage its content
 */
const manageTensionInstructionsContent = () => {
    const $tensionInstructionsContent =  $(".tension-instructions-content");
    const $tensionInstructionsButtonExpand = $(".tension-instructions-button-expand");
    const $tensionInstructionsButtonCollapse = $(".tension-instructions-button-collapse");

    if ($tensionInstructionsContent.length && $tensionInstructionsContent.height() > 80) {
        $tensionInstructionsContent.addClass("collapsed");
        $tensionInstructionsButtonExpand.removeClass("d-none");
    }

    $document.on("click", ".tension-instructions-button-expand", () => {
        $tensionInstructionsButtonExpand.addClass("d-none");
        $tensionInstructionsContent.removeClass("collapsed");
        $tensionInstructionsButtonCollapse.removeClass("d-none");
    });

    $document.on("click", ".tension-instructions-button-collapse", () => {
        $tensionInstructionsButtonCollapse.addClass("d-none");
        $tensionInstructionsContent.addClass("collapsed");
        $tensionInstructionsButtonExpand.removeClass("d-none");
    });
};

/**
 * @function
 * @description Function to intercept variation selection
 */
const interceptVariationSelection = () => {
    const $variationForm = $("#stringVariationAttributes");
    let url = $variationForm.data("url");
    let masterId = $variationForm.data("master-id");
    let variationAttributes = $variationForm.find(".strings-variation-item");
    let tensionValues = $body.find("#form-add-stringing .js-required-tension");
    let first = true;
    let missingValues = 0;

    variationAttributes.each((i, el) => {
        const attrID = $(el).data("variation-attr");
        const attrValue = $(el).find(".js-strings-option.selected").data("attr-value");

        if (typeof attrValue == "undefined") {
            missingValues++;
        }

        if (first) {
            url = url + "?";
            first = false;
        } else {
            url = url + "&";
        }

        url = url + attrID + "=" + attrValue;
    });

    url = url + "&pid=" + masterId + "&quantity=1";

    tensionValues.each((i, el) => {
        if (!$(el).val()) {
            missingValues++;
        }
    });

    $("#validate-tensions").attr("disabled", "disabled");

    if (missingValues == 0) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: "GET",
            success: data => {
                var $productContainer = $("#config-tensions");

                if (data.product && data.product.variationAttributes) {
                    base.updateAttrs(data.product.variationAttributes, $productContainer, data.resources);
                }

                if (data.product) {
                    const $priceSelector = $(".string-product-prices", $productContainer);

                    $priceSelector.empty().html(data.product.price.html);
                }

                $("#stringVariantPid").val(data.product.id);
                var $stringSelectionBlock = $("#config-tensions");
                if (data.product && data.product.available) {
                    $("#validate-tensions").removeAttr("disabled");
                    $stringSelectionBlock.find(".out-of-stock-msg").addClass("d-none");
                    $stringSelectionBlock.find(".string-price").removeClass("d-none");
                    $("#validate-tensions").removeClass("out-of-stock");
                } else {
                    $stringSelectionBlock.find(".out-of-stock-msg").removeClass("d-none");
                    $stringSelectionBlock.find(".string-price").addClass("d-none");
                    $("#validate-tensions").attr("disabled", "disabled");
                    $("#validate-tensions").addClass("out-of-stock");
                }

                $.spinner().stop();

                setTimeout(() => {
                    if (window.mqRespond.status.lgDown) {
                        $("html, body").animate({ scrollTop: $("#stringVariationAttributes").offset().top - $(".l-header").height() }, "slow");
                    } else {
                        $("html, body").animate({ scrollTop: $(".m-product-detail__stringing-wrapper").offset().top - $(".l-header").height() }, "slow");
                    }
                }, 200);
            },
            error: () => {
                $.spinner().stop();
            }
        });
    }
};

module.exports = {
    stringingStart: () => {
        $body.on("click", ".btn-stringing", e => {
            e.preventDefault();
            $(e.target).toggleClass("stringing-active", true);
            $body.trigger("stringing:start");
        });
    },

    stringingFormSubmit: () => {
        $body.on("click", "#validate-tensions", () => {
            $body.find("#form-add-stringing").trigger("submit");
        });
    },

    validateTensions: () => {
        $body.on("submit", "#form-add-stringing", e => {
            e.preventDefault();

            let form = $(e.currentTarget);
            let url = form.attr("action");

            $.spinner().start();

            $.ajax({
                url: url,
                type: "post",
                data: form.serialize(),
                success: data => {
                    base.methods.handlePostCartAdd(data);
                    $body.trigger("product:afterAddToCart", data);
                    $.spinner().stop();
                    base.miniCartReportingUrl(data.reportingURL);
                },
                error: (e) => {
                    var response = JSON.parse(e.responseText);
                    if ($(".add-to-cart-messages").length === 0) {
                        $("body").append("<div class=\"add-to-cart-messages\"></div>");
                    }
                    $(".add-to-cart-messages").append("<div class=\"alert alert-danger add-to-basket-alert c-form-state c-form-state--error\"" + " role=\"alert\">" + response.errorMessage + "</div>");
                    setTimeout(function () {
                        $(".add-to-basket-alert").remove();
                    }, 3000);
                    $.spinner().stop();
                }
            });
        });
    },

    changeSelectedVariation: () => {
        $document.on("initChangeVariation", () => {
            interceptVariationSelection();
        });

        $body.on("change", "select.strings-select", elem => {
            elem.preventDefault();

            const $this = $(elem.currentTarget);

            $this.find(".js-strings-option").removeClass("selected");
            $this.find("option:selected").addClass("selected");
            $document.trigger("initChangeVariation");
        });

        $body.on("change", ".js-required-tension", () => {
            $document.trigger("initChangeVariation");
        });
    },

    interceptStringTileClick: () => {
        $body.on("click", "#config-stringing .product-tile", e => {
            e.preventDefault();

            let $target = $(e.target);

            if (!$target.hasClass("slick-arrow")) {
                let tensionsURL = $("#config-stringing").data("tensions-url");
                let pid = $(".m-product-detail").data("pid");
                let stringPid = $target.closest(".product").data("pid");
                let $selectedSliderItem = $target.closest(".product-tile");
                let $selectedSlide = $target.closest(".slick-slide");
                let $selectedSliderRating = $selectedSliderItem.find(".m-product-detail__rating");
                let isPlayTestProduct = $(".m-product-detail").hasClass("play-test-product");

                if ($selectedSliderItem.length) {
                    $(".product-tile").removeClass("active-string");

                    if (window.mqRespond.status.smOnly || window.mqRespond.status.xsOnly) {
                        $(".stringing-slider").slick("slickGoTo", $selectedSlide.data("slick-index"));
                        $(".slick-active").find(".product-tile").addClass("active-string");
                    } else {
                        $selectedSliderItem.addClass("active-string");
                    }
                }

                $.ajax({
                    url: tensionsURL + "?pid=" + pid + "&stringPid=" + stringPid + (isPlayTestProduct ? "&isPlayTest=true" : ""),
                    type: "get",
                    success: data => {
                        const $tensionsSection = $("#config-tensions");
                        $tensionsSection.html(data);
                        lazyLoading.refreshLazyLoadingFeature(".m-product-detail__stringing-image img");
                        manageTensionInstructionsContent();

                        const $stringRating = $(".js-stringing-rating");
                        const $stringColorButton = $(".strings-color-attribute");

                        if ($selectedSliderRating.length > 0) {
                            $stringRating.append($selectedSliderItem.find(".m-product-detail__rating")[0].outerHTML);
                        }

                        setTimeout(() => {
                            if (window.mqRespond.status.smOnly || window.mqRespond.status.xsOnly) {
                                $("html, body").animate({ scrollTop: $(".m-product-detail__stringing-title").offset().top - $(".l-header").height() - 20 }, "slow");
                            } else {
                                $("html, body").animate({ scrollTop: $tensionsSection.offset().top - $(".l-header").height() }, "slow");
                            }
                        }, 500);

                        if ($stringColorButton.length > 0) {
                            setTimeout(function () {
                                interceptVariationSelection();
                                $stringColorButton.first().trigger("click");
                            }, 1000);
                        }
                    }
                });
            }
        });
    },

    synchronizeModelSelection: () => {
        $body.on("change", ".model-select", elem => {
            const $this = $(elem.currentTarget);

            $(".model-select").find("option").each((i, el) => {
                $(el).removeAttr("selected");
            });

            $this.find("option:selected").attr("selected", "selected");

            if ($this.hasClass("crosses-model-select")) {
                if ($this.find("option:selected").hasClass("first-model")) {
                    $document.find(".mains-model-select .second-model").prop("selected", true);
                } else {
                    $document.find(".mains-model-select .first-model").prop("selected", true);
                }

                $document.find(".mains-model-select").prop("disabled", true);
            } else {
                if ($this.find("option:selected").hasClass("first-model")) {
                    $document.find(".crosses-model-select .second-model").prop("selected", true);
                } else {
                    $document.find(".crosses-model-select .first-model").prop("selected", true);
                }

                $document.find(".crosses-model-select").prop("disabled", true);
            }
        });
    },

    startStringingService: function () {
        $("body").on("stringing:start", function() {
            const configUrl = $("#findStringingShop").data("config");

            if (configUrl) {
                loadStringingConfig(configUrl);
            }
        });
    }
};
